import { apiClient } from './authApi';
import {
  LibraryFolder,
  LibraryFile,
  LibraryFaq,
  CreateFolderDto,
  UpdateFolderDto,
  UpdateFileDto,
  CreateFaqDto,
  UpdateFaqDto,
} from '../../types/library';

// ==================== Folders ====================

export const libraryApi = {
  // Folders
  getFolderTree: async (): Promise<LibraryFolder[]> => {
    const response = await apiClient.get('/library/folders/tree');
    return response.data.data;
  },

  getFolders: async (): Promise<LibraryFolder[]> => {
    const response = await apiClient.get('/library/folders');
    return response.data.data;
  },

  getFolder: async (id: number): Promise<LibraryFolder> => {
    const response = await apiClient.get(`/library/folders/${id}`);
    return response.data.data;
  },

  createFolder: async (data: CreateFolderDto): Promise<LibraryFolder> => {
    const response = await apiClient.post('/library/folders', data);
    return response.data.data;
  },

  updateFolder: async (id: number, data: UpdateFolderDto): Promise<LibraryFolder> => {
    const response = await apiClient.put(`/library/folders/${id}`, data);
    return response.data.data;
  },

  deleteFolder: async (id: number): Promise<void> => {
    await apiClient.delete(`/library/folders/${id}`);
  },

  reorderFolders: async (items: { id: number; sort_order: number }[]): Promise<void> => {
    await apiClient.put('/library/folders/reorder', { items });
  },

  // Files
  getFilesByFolder: async (folderId: number): Promise<LibraryFile[]> => {
    const response = await apiClient.get(`/library/files/folder/${folderId}`);
    return response.data.data;
  },

  getAllFiles: async (): Promise<LibraryFile[]> => {
    const response = await apiClient.get('/library/files');
    return response.data.data;
  },

  uploadFile: async (formData: FormData): Promise<LibraryFile> => {
    const response = await apiClient.post('/library/files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },

  downloadFile: async (id: string): Promise<{ url: string; original_name: string }> => {
    const response = await apiClient.get(`/library/files/${id}/download`);
    return response.data.data;
  },

  updateFile: async (id: string, data: UpdateFileDto): Promise<LibraryFile> => {
    const response = await apiClient.put(`/library/files/${id}`, data);
    return response.data.data;
  },

  deleteFile: async (id: string): Promise<void> => {
    await apiClient.delete(`/library/files/${id}`);
  },

  // FAQ
  getFaqs: async (category?: string): Promise<LibraryFaq[]> => {
    const params = category ? { category } : {};
    const response = await apiClient.get('/library/faq', { params });
    return response.data.data;
  },

  createFaq: async (data: CreateFaqDto): Promise<LibraryFaq> => {
    const response = await apiClient.post('/library/faq', data);
    return response.data.data;
  },

  updateFaq: async (id: number, data: UpdateFaqDto): Promise<LibraryFaq> => {
    const response = await apiClient.put(`/library/faq/${id}`, data);
    return response.data.data;
  },

  deleteFaq: async (id: number): Promise<void> => {
    await apiClient.delete(`/library/faq/${id}`);
  },
};
